<template>
  <div v-if="getSelectedFilters" class="row mb20">
    <label class="col-xs-12 uppercase align-left weight-600">{{
        $t("Choose size")
      }}</label>
    <div
      class="row col-xs-12 radio-input-wrapper"
    >
      <div
        v-for="size in sizes"
        :key="size.value"
        class="radio-input relative flexible mt5"
      >
        <input
          v-model="getSelectedFilters"
          :value="size.value"
          :id="size.value + '-' + rentType"
          :name="'size-' + rentType"
          :disabled="isDisabled"
          type="radio"
        />
        <label :for="size.value + '-' + rentType" class="radioStyled fs13">
          {{ size.label }}
        </label>
      </div>
    </div>
    <div
      v-if="getCurrentProduct.size_guide"
      class="size-guide col-xs-12 mt5 pointer"
      @click="$bus.$emit('modal-show', 'modal-size')"
    >
      <img src="/assets/clothes-hanger.svg" alt="hanger">
      <span class="underline">{{ $t("Size guide") }}</span>  
    </div>
  </div>
</template>

<script>
import {
  getAvailableFiltersByProduct,
  getSelectedFiltersByProduct,
} from "@vue-storefront/core/modules/catalog/helpers/filters";
import { mapGetters } from "vuex";
import { filterChangedProduct } from "@vue-storefront/core/modules/catalog/events";
import EventBus from '@vue-storefront/core/compatibility/plugins/event-bus'

export default {
  name: "Size",

  props: {
    rentType: {
      type: String,
      default: "single",
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      getCurrentProduct: "product/getCurrentProduct",
      getCurrentProductConfiguration: "product/getCurrentProductConfiguration",
      getDeliveries: "calendar/getDeliveries",
      isLogged: "user/isLoggedIn",
      getUserBalance: "user/getBalance",
    }),
    getSelectedFilters: {
      get () {
        return getSelectedFiltersByProduct(
          this.getCurrentProduct,
          this.getCurrentProductConfiguration
        ).size?.label;
      },
      set (value) {
        this.updateSize(value)
      }
    },
    sizes() {
      let sizes = getAvailableFiltersByProduct(this.getCurrentProduct)["size"];
      let result = [];
      sizes.map((size) => result.push({ ...size, value: size.label }));
      return result;
    },
    isEnoughPoints() {
      return this.getUserBalance >= 1;
    },
    isDisabled() {
      return (
        this.rentType === "subscription" &&
        (!this.isEnoughPoints || !this.isLogged)
      );
    },
  },
  methods: {
    updateDelivery(value) {
      if (value) this.$store.commit("calendar/updateDelivery", value);
      this.$store.dispatch("calendar/loadCalendarData", {
        sku: this.getCurrentProduct.sku,
      });
      EventBus.$emit('resetCalendarDate')
    },
    async updateSize(value) {
      const variant = this.sizes.find((size) => size.label === value);
      const selectedConfiguration = Object.assign(
        { attribute_code: variant.type },
        variant
      );
      await filterChangedProduct(
        selectedConfiguration,
        this.$store,
        this.$router
      );
      await this.$store.dispatch("stock/getQuantity");
      this.setAvaliableSourceCodes();
      this.updateDelivery();
      EventBus.$emit('resetCalendarDate')
    },
    setAvaliableSourceCodes() {
      if (
        this.getCurrentProduct.stock &&
        this.getCurrentProduct.stock.source_codes &&
        this.getCurrentProduct.stock.source_codes.length
      ) {
        this.$store.commit(
          "calendar/setAvailableDeliveries",
          this.getCurrentProduct.stock.source_codes
        );
      } else {
        this.$store.commit("calendar/setAvailableDeliveries", []);
      }
      this.$store.dispatch("calendar/loadCalendarData", {
        sku: this.getCurrentProduct.sku,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.radio-input {
   flex-basis: 90px;
   label {
    padding: 10px 0px;
    text-align: center;
    border: 1px solid #DCDCDC;
    color: #646464;
    display: block;
    text-transform: uppercase;
    font-size: 13px;
    cursor: pointer;
  }
  input {
    display: none;
    position: absolute;
    top: 3px;
    left: 0;
    &:checked + label {
      box-shadow: 0px 0px 0px 2px #3e3e3e !important;
      color: black;
      background-color: #F5D2D2;
    }
    &:hover,
    &:focus {
      + label {
        box-shadow: 0px 0px 0px 1px #3e3e3e;
      }
    }
    &:disabled + label {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}
.flexible {
  padding: 0 8px;
}
.size-guide {
  color: #676776;
  img, span {
    vertical-align: middle;
    display: inline-block;
  }
}
</style>
